import React, { useState } from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div style={{ padding: '1.5rem' }}>
          {children}
        </div>
      )}
    </div>
  );
}

const StudentNotes: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  // 샘플 데이터
  const recentMaterials = [
    {
      id: '1',
      title: '수학 기초 개념 정리',
      subject: '수학',
      grade: '중1',
      description: '중학교 1학년 수학의 기초 개념들을 정리한 자료입니다.',
      author: '김수학',
      fileType: 'PDF',
      uploadDate: '2024-01-15',
      downloadCount: 156,
      tags: ['기초', '개념정리', '중1'],
      isFavorite: true
    },
    {
      id: '2',
      title: '과학 실험 가이드',
      subject: '과학',
      grade: '중2',
      description: '중학교 2학년 과학 실험을 위한 상세한 가이드입니다.',
      author: '이과학',
      fileType: 'PDF',
      uploadDate: '2024-01-14',
      downloadCount: 89,
      tags: ['실험', '가이드', '중2'],
      isFavorite: false
    }
  ];

  const myNotes = [
    {
      id: '1',
      title: '내가 작성한 노트 1',
      content: '수학 공식 정리...',
      createdAt: '2024-01-15',
      updatedAt: '2024-01-15'
    },
    {
      id: '2',
      title: '내가 작성한 노트 2',
      content: '과학 실험 결과...',
      createdAt: '2024-01-14',
      updatedAt: '2024-01-14'
    }
  ];

  return (
    <div style={{ 
      maxWidth: '1200px', 
      margin: '0 auto', 
      padding: '2rem',
      backgroundColor: '#f5f7fa',
      minHeight: '100vh'
    }}>
      {/* 헤더 */}
      <div style={{ marginBottom: '2rem' }}>
        <h1 style={{ 
          fontSize: '2.5rem', 
          fontWeight: 'bold', 
          marginBottom: '0.5rem',
          color: '#333'
        }}>
          나의 학습 노트
        </h1>
        <p style={{ 
          fontSize: '1.2rem', 
          color: '#666',
          marginBottom: '1rem'
        }}>
          학습 자료를 확인하고 나만의 노트를 작성해보세요
        </p>
        <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0' }} />
      </div>

      {/* 탭 */}
      <div style={{ 
        borderBottom: '1px solid #e0e0e0', 
        marginBottom: '1.5rem' 
      }}>
        <div style={{ display: 'flex' }}>
          {['최근 자료', '내 노트', '즐겨찾기'].map((label, index) => (
            <button
              key={index}
              onClick={() => setTabValue(index)}
              style={{
                padding: '1rem 2rem',
                border: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                borderBottom: tabValue === index ? '2px solid #1976d2' : '2px solid transparent',
                color: tabValue === index ? '#1976d2' : '#666',
                fontWeight: tabValue === index ? 'bold' : 'normal',
                fontSize: '1rem'
              }}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <TabPanel value={tabValue} index={0}>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
          gap: '1.5rem' 
        }}>
          {recentMaterials.map((material, index) => (
            <div
              key={material.id}
              style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '1.5rem',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                border: '1px solid #e0e0e0'
              }}
            >
              <div style={{ marginBottom: '1rem' }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  marginBottom: '0.5rem' 
                }}>
                  <h3 style={{ 
                    fontSize: '1.2rem', 
                    fontWeight: 'bold', 
                    marginRight: '1rem',
                    color: '#333'
                  }}>
                    {material.title}
                  </h3>
                  <span style={{
                    padding: '0.25rem 0.5rem',
                    backgroundColor: '#1976d2',
                    color: 'white',
                    borderRadius: '4px',
                    fontSize: '0.8rem'
                  }}>
                    {material.fileType}
                  </span>
                  {material.isFavorite && (
                    <span style={{ marginLeft: '0.5rem', color: '#ff9800' }}>⭐</span>
                  )}
                </div>
                <p style={{ 
                  color: '#666', 
                  marginBottom: '1rem',
                  lineHeight: '1.5'
                }}>
                  {material.description}
                </p>
              </div>
              
              <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: '0.5rem', 
                marginBottom: '1rem' 
              }}>
                <span style={{
                  padding: '0.25rem 0.5rem',
                  backgroundColor: '#1976d2',
                  color: 'white',
                  borderRadius: '12px',
                  fontSize: '0.8rem'
                }}>
                  {material.subject}
                </span>
                <span style={{
                  padding: '0.25rem 0.5rem',
                  backgroundColor: 'transparent',
                  color: '#666',
                  border: '1px solid #e0e0e0',
                  borderRadius: '12px',
                  fontSize: '0.8rem'
                }}>
                  {material.grade}
                </span>
                <span style={{
                  padding: '0.25rem 0.5rem',
                  backgroundColor: 'transparent',
                  color: '#666',
                  border: '1px solid #e0e0e0',
                  borderRadius: '12px',
                  fontSize: '0.8rem'
                }}>
                  작성자: {material.author}
                </span>
              </div>
              
              <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: '0.5rem', 
                marginBottom: '1rem' 
              }}>
                {material.tags.map((tag, tagIndex) => (
                  <span
                    key={tagIndex}
                    style={{
                      padding: '0.25rem 0.5rem',
                      backgroundColor: 'transparent',
                      color: '#666',
                      border: '1px solid #e0e0e0',
                      borderRadius: '12px',
                      fontSize: '0.75rem'
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '1rem', 
                color: '#666',
                marginBottom: '1rem',
                fontSize: '0.9rem'
              }}>
                <span>📅 {material.uploadDate}</span>
                <span>⬇️ {material.downloadCount}회 다운로드</span>
              </div>
              
              <div style={{ 
                display: 'flex', 
                gap: '0.5rem' 
              }}>
                <button
                  onClick={() => console.log('자료 다운로드:', material.id)}
                  style={{
                    padding: '0.5rem 1rem',
                    backgroundColor: '#1976d2',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  ⬇️ 다운로드
                </button>
                <button
                  onClick={() => console.log('자료 상세:', material.id)}
                  style={{
                    padding: '0.5rem 1rem',
                    backgroundColor: 'transparent',
                    color: '#1976d2',
                    border: '1px solid #1976d2',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  👁️ 상세 보기
                </button>
                <button
                  onClick={() => console.log('즐겨찾기 토글:', material.id)}
                  style={{
                    padding: '0.5rem 1rem',
                    backgroundColor: material.isFavorite ? '#ff9800' : 'transparent',
                    color: material.isFavorite ? 'white' : '#ff9800',
                    border: '1px solid #ff9800',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  {material.isFavorite ? '⭐ 즐겨찾기 해제' : '⭐ 즐겨찾기'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
          gap: '1.5rem' 
        }}>
          {myNotes.map((note, index) => (
            <div
              key={note.id}
              style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '1.5rem',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                border: '1px solid #e0e0e0'
              }}
            >
              <h3 style={{ 
                fontSize: '1.2rem', 
                fontWeight: 'bold', 
                marginBottom: '1rem',
                color: '#333'
              }}>
                {note.title}
              </h3>
              <p style={{ 
                color: '#666', 
                marginBottom: '1rem',
                lineHeight: '1.5'
              }}>
                {note.content}
              </p>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                marginBottom: '1rem',
                fontSize: '0.9rem',
                color: '#666'
              }}>
                <span>작성일: {note.createdAt}</span>
                <span>수정일: {note.updatedAt}</span>
              </div>
              <div style={{ 
                display: 'flex', 
                gap: '0.5rem' 
              }}>
                <button
                  onClick={() => console.log('노트 편집:', note.id)}
                  style={{
                    padding: '0.5rem 1rem',
                    backgroundColor: '#1976d2',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  ✏️ 편집
                </button>
                <button
                  onClick={() => console.log('노트 삭제:', note.id)}
                  style={{
                    padding: '0.5rem 1rem',
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  🗑️ 삭제
                </button>
              </div>
            </div>
          ))}
        </div>
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <div style={{ 
          backgroundColor: 'white', 
          padding: '3rem', 
          textAlign: 'center',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>⭐</div>
          <h3 style={{ 
            fontSize: '1.5rem', 
            color: '#666', 
            marginBottom: '0.5rem' 
          }}>
            즐겨찾기한 자료가 없습니다
          </h3>
          <p style={{ color: '#999' }}>
            자료를 즐겨찾기에 추가하면 여기에 표시됩니다
          </p>
        </div>
      </TabPanel>
    </div>
  );
};

export default StudentNotes;